import HeroAbout from '#app/components/hero-about.tsx';
import Recruitment from '#app/components/recruitment.tsx';
import Story from '#app/components/story.tsx';
import Footer from '#app/components/ui/footer.tsx';
import Header from '#app/components/ui/header.tsx';

export default function About() {
	return (
		<>
			<Header />

			<main className="grow">
				<HeroAbout />
				<Story />
				<Recruitment />
			</main>

			<Footer />
		</>
	);
}
